import { onConnect } from '@reatom/framework'

import { AsyncStateN, pipe, Result } from '@blade/std-lib'
import { newTxEvent } from '@root/entities/realtime/atoms/new-tx-event'
import { fetchHoldersRequestAction } from '@root/features/trade/holders'
import { reatomDataTable } from '@root/shared/ui-kit'

import { holdersSwapUpdateHandler } from '../../common/holders-swap-update-handler'

import { createPairHoldersTableColumns } from './reatom-pair-holders-columns'

import type { PairModel } from '@root/entities/pair'
import type { Maker } from '@root/entities/trade'
import type { TableData } from '@root/shared/ui-kit'

export const reatomPairHoldersTable = (options: { pair: PairModel }) => {
  const tableModel = reatomDataTable({
    columns: createPairHoldersTableColumns({ pair: options.pair }),
    initialSorting: {
      sortColumn: 'rank',
      sortDirection: 'desc',
    },
    // eslint-disable-next-line @reatom/unit-naming-rule
    name: 'pair-holders-table',
    loadItems: async (ctx, { filters }) => {
      const result = await fetchHoldersRequestAction(ctx, {
        network: options.pair.network,
        pairAddress: options.pair.address,
      })

      return pipe(
        result,
        Result.map(
          (data): TableData<Maker.RankedMaker> => ({
            data: data.filter((holder) => {
              const { maker } = filters
              if (maker && maker.type === 'string' && maker.operator === 'eq') {
                return holder.address === maker.value
              }
              return true
            }),
            hasNext: false,
          }),
        ),
      )
    },
    getId: (item) => item.address,
  })

  onConnect(tableModel, () => {
    const unsubscribe = newTxEvent.onCall((ctx, swap) => {
      if (
        swap.pairAddress === options.pair.address &&
        swap.network === options.pair.network
      ) {
        tableModel.setState(
          ctx,
          AsyncStateN.map((prev) => {
            return { ...prev, data: holdersSwapUpdateHandler(prev.data, swap) }
          }),
        )
      }
    })

    return () => {
      unsubscribe()
    }
  })

  return tableModel
}
